import * as Yup from "yup";

export const initialValues = (data) => {
  return {
    ...data,
    ...data?.localized_data,
  };
};

export const structure = (t) => [
  {
    head: "",
    width: "100%",
    list: [
      {
        name: `icon`,
        kind: "upload",
        type: 'icon',
        label: t("occasions_types.upload_icon"),
        text: t("occasions_types.file_types"),
        width: "47%",
        id: 0
      },
      {
        name: `banner`,
        kind: "upload",
        type: 'image',
        label: t("occasions_types.upload_banner"),
        text: t("occasions_types.file_types"),
        width: "47%",
        id: 1
      },
      {
        name: `en.name`,
        kind: "input",
        type: "text",
        label: `${t("occasions_types.name_en")}*`,
        width: "47%",
        placeholder: t("occasions_types.write_name_en")
      },
      {
        name: `ar.name`,
        kind: "input",
        type: "text",
        label: `${t("occasions_types.name_ar")}*`,
        width: "47%",
        placeholder: t("occasions_types.write_name_ar")
      },
      {
        name: `en.description`,
        kind: "textArea",
        type: "text",
        label: t("occasions_types.description_en"),
        width: "47%",
        placeholder: t("occasions_types.write_description_en"),
        colSpan: 6
      },
      {
        name: `ar.description`,
        kind: "textArea",
        type: "text",
        label: t("occasions_types.description_ar"),
        width: "47%",
        placeholder: t("occasions_types.write_description_ar"),
        colSpan: 6
      },
    ],
  },
];


export const validationSchema = (t) =>
  Yup.object({
    // icon: Yup.string().required('Required'),
    // banner: Yup.string().required('Required'),
    en: Yup.object().shape({
      name: Yup.string().required(t("common.required")),
      // description: Yup.string(),
    }),
    ar: Yup.object().shape({
      name: Yup.string().required(t("common.required")),
      // description: Yup.string(),
    }),
  },
  );